/**
 * SxS Network — Garage Fitment Matcher (v3.1)
 * v3.1 (3 Oct 2026): font sizes in px — the theme sets html{font-size:10px}, so rem rendered at 62.5%.
 * ------------------------------------------
 * v3 (2 Oct 2026): reads the product's custom.fitment_display metafield from
 *   <script type="application/json" id="sxsn-fitment-json"> (emitted by
 *   snippets/meta-tags.liquid on product pages) and matches it against the
 *   garage via SxSNGarage.matchesDisplay(). Falls back to the v2 tag-based
 *   data div (#sxsn-product-fitment) when the metafield is empty.
 *   The store tag "Universal" → "Universal fit" badge.
 * v2 (kept): amber "not verified" state when no fitment data exists.
 *
 * Expected on the product page:
 *   <span id="sxsn-garage-badge"></span>   (from sections/main-product.liquid)
 */

(function() {
  function parseList(str) {
    if (!str) return [];
    return str.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
  }
  function parseYears(str) {
    return parseList(str).map(function(y) { return parseInt(y, 10); }).filter(function(y) { return !isNaN(y); });
  }
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function readFitmentJson() {
    var el = document.getElementById('sxsn-fitment-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function buildBadge(matches) {
    if (!matches || matches.length === 0) {
      // Garage has machines, product has data, nothing matched → say so plainly
      return '' +
        '<div class="sxsn-fits-badge sxsn-fits-nomatch" style="' +
          'background:#fff;border:1px solid #ccc;color:#444;' +
          'padding:10px 14px;border-radius:6px;display:inline-flex;align-items:center;gap:8px;' +
          'font-weight:600;font-size:13.5px;line-height:1.3;">' +
          '<span style="color:#999;">○</span>' +
          '<span>Not listed for the machines in your garage — ' +
            '<a href="/pages/my-garage" style="color:#ff5400;font-weight:700;text-decoration:none;">check your garage</a>' +
          '</span>' +
        '</div>';
    }

    if (matches[0] && matches[0].dataIncomplete) {
      return '' +
        '<div class="sxsn-fits-badge sxsn-fits-incomplete" style="' +
          'background:#1a1a1a;border:1px solid #ff5400;color:#fff;' +
          'padding:11px 16px;border-radius:4px;' +
          'display:inline-flex;align-items:center;gap:10px;font-weight:600;' +
          'font-size:14px;line-height:1.3;letter-spacing:0.01em;">' +
          '<span style="color:#ff5400;font-size:11px;line-height:1;">●</span>' +
          '<span>Fitment not verified for your machine — ' +
            '<a href="sms:+17194286837?body=Will%20this%20fit%20my%20machine%3F" ' +
              'style="color:#ff5400;text-decoration:underline;font-weight:700;">' +
              'verify with our team' +
            '</a>' +
          '</span>' +
        '</div>';
    }

    var primary = matches.find(function(m) { return m.matchType === 'trim_exact'; })
                  || matches.find(function(m) { return m.matchType === 'exact'; })
                  || matches.find(function(m) { return m.matchType === 'model'; })
                  || matches.find(function(m) { return m.matchType === 'universal'; })
                  || matches[0];

    var labelMap = {
      'trim_exact': 'Trim-confirmed fit:',
      'exact':      'Fits your',
      'model':      'Listed for your',
      'universal':  'Universal fit — covers your'
    };
    var bgMap = { 'trim_exact': '#1f9d3a', 'exact': '#1f9d3a', 'model': '#3a6dbd', 'universal': '#3a6dbd' };
    var iconMap = { 'trim_exact': '✓', 'exact': '✓', 'model': '⓵', 'universal': '★' };

    var icon = iconMap[primary.matchType] || '✓';
    var label = labelMap[primary.matchType] || 'Fits your';
    var bg = bgMap[primary.matchType] || '#1f9d3a';
    var machineLabel = escapeHtml(window.SxSNGarage.formatLabel(primary.machine));

    var html = '' +
      '<div class="sxsn-fits-badge" style="' +
        'background:' + bg + ';color:#fff;padding:10px 14px;border-radius:6px;' +
        'display:inline-flex;align-items:center;gap:8px;font-weight:700;' +
        'font-size:14.5px;line-height:1.3;">' +
        '<span class="sxsn-fits-icon" style="font-size:17px;">' + icon + '</span>' +
        '<span class="sxsn-fits-text">' + label + ' ' + machineLabel + '</span>' +
      '</div>';

    if (primary.matchType === 'exact' && primary.line) {
      html += '<div class="sxsn-fits-line" style="font-size:12.5px;color:#666;margin-top:6px;">' +
        'Manufacturer fitment: ' + escapeHtml(primary.line) + '</div>';
    }
    if (primary.matchType === 'model') {
      html += '<div class="sxsn-fits-caution" style="font-size:12.5px;color:#888;margin-top:6px;">' +
        'Year not confirmed' + (primary.line ? ' (listed: ' + escapeHtml(primary.line) + ')' : '') + ' — ' +
        '<a href="sms:+17194286837?body=Will%20this%20part%20fit%20my%20machine%3F" ' +
          'style="color:#ff5400;font-weight:700;">verify with our team</a> before purchase.' +
      '</div>';
    }
    if (matches.length > 1 && !matches[0].dataIncomplete) {
      html += '<div class="sxsn-fits-others" style="font-size:12.5px;color:#888;margin-top:4px;">' +
              '+ ' + (matches.length - 1) + ' more in your garage</div>';
    }
    return html;
  }

  function buildEmptyBadge() {
    return '' +
      '<div class="sxsn-fits-badge sxsn-fits-empty" style="' +
        'background:#1a1a1a;border:1px solid #ff5400;color:#ff5400;' +
        'padding:10px 14px;border-radius:6px;display:inline-flex;' +
        'align-items:center;gap:8px;font-weight:700;font-size:13.5px;">' +
        '<a href="/pages/my-garage" style="color:#ff5400;text-decoration:none;">' +
          '🚙 Add your machine to see if this fits' +
        '</a>' +
      '</div>';
  }

  function applyBadge() {
    var badgeEl = document.getElementById('sxsn-garage-badge');
    if (!badgeEl || !window.SxSNGarage) return;

    if (window.SxSNGarage.count() === 0) {
      badgeEl.innerHTML = buildEmptyBadge();
      return;
    }

    var fj = readFitmentJson();
    var matches;
    if (fj && (fj.universal || (fj.display && fj.display.trim()))) {
      matches = window.SxSNGarage.matchesDisplay(fj.display || '', !!fj.universal);
    } else {
      var fitmentEl = document.getElementById('sxsn-product-fitment');
      if (!fitmentEl) return;
      var fitment = {
        fits_makes: parseList(fitmentEl.getAttribute('data-fits-makes')),
        fits_models: parseList(fitmentEl.getAttribute('data-fits-models')),
        fits_years: parseYears(fitmentEl.getAttribute('data-fits-years')),
        fits_trims: parseList(fitmentEl.getAttribute('data-fits-trims')),
        type: fitmentEl.getAttribute('data-fitment-type') || 'unknown'
      };
      matches = window.SxSNGarage.matches(fitment);
    }
    badgeEl.innerHTML = buildBadge(matches);
  }

  function syncOneSignalTags() {
    if (!window.OneSignal || !window.SxSNGarage) return;
    window.OneSignal.push(function() {
      var primary = window.SxSNGarage.getPrimary();
      if (!primary) return;
      var tags = {
        garage_make: primary.make || '',
        garage_model: primary.model || '',
        garage_year: primary.year ? String(primary.year) : '',
        garage_count: String(window.SxSNGarage.count())
      };
      try { window.OneSignal.sendTags(tags); } catch (e) { /* ignore */ }
    });
  }

  function init() {
    applyBadge();
    syncOneSignalTags();
    if (window.SxSNGarage && window.SxSNGarage.onChange) {
      window.SxSNGarage.onChange(function() { applyBadge(); syncOneSignalTags(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
